import React, { useState } from "react";
import styles from "./Warehouse.module.css";

const Misc = () => {
  const initialPermissions = [
    { name: "Журнал активности", columns: ["view"] },
    { name: "Аналитика", columns: ["view"] },
    { name: "Разрешение на изменение Wipon Cashback", columns: ["view", "edit"] },
    { name: "Комиссии", columns: ["view", "create", "edit", "delete"] },

    { name: "Информация о компании", columns: ["view", "edit"] },
    { name: "Ключи и оплаты", columns: ["view", "edit"] },
    { name: "Сотрудник компании (ЗУП)", columns: ["view", "create", "edit", "delete"] },

    { name: "Документ", columns: ["view", "create", "edit", "delete"] },
    { name: "Сотрудники", columns: ["view", "create", "edit", "delete"] },

    { name: "Доходы/Расходы", columns: ["view", "create", "edit", "delete"] },
    { name: "Категории товаров", columns: ["view", "create", "edit"] },

    { name: "Денежные движения", columns: ["view", "create", "edit", "delete"] },
    { name: "Категории движения денежных средств", columns: ["view", "create", "edit"] },

    { name: "Способы оплаты", columns: ["view", "create", "edit", "delete"] },

    { name: "Роли", columns: ["view", "create", "edit", "delete"] },

    { name: "Отчёты по сменам", columns: ["view"] },

    { name: "Налоговая отчётность", columns: ["view", "create"] },

    { name: "Единицы измерения", columns: ["view", "create", "edit", "delete"] },

    { name: "Денежный счёт", columns: ["view", "create", "edit"] },
    { name: "Баланс денежного счёта", columns: ["view"] },
  ];

  const [terminalAccess, setTerminalAccess] = useState(false);
  const [permissions, setPermissions] = useState(() => {
    const obj = {};
    initialPermissions.forEach((item) => {
      obj[item.name] = {};
      item.columns.forEach((col) => {
        obj[item.name][col] = false;
      });
    });
    return obj;
  });

  const handleCheckboxChange = (row, key) => {
    setPermissions({
      ...permissions,
      [row]: {
        ...permissions[row],
        [key]: !permissions[row][key],
      },
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <label>Название роли</label>
        <input type="text" className={styles.roleInput} />

        <div className={styles.terminalWrapper}>
          <label className={styles.terminalLabel}>
            <label className={styles.checkboxContainer}>
              <input
                type="checkbox"
                checked={terminalAccess}
                onChange={() => setTerminalAccess(!terminalAccess)}
              />
              <span className={styles.customCheckbox}></span>
            </label>
            <span className={styles.text}>Доступ только в терминал</span>
          </label>
        </div>
      </div>

      {/* Контейнер со скроллом */}
      <div className={styles.tableScroll}>
        <table className={styles.permissionTable}>
          <thead>
            <tr>
              <th>Название</th>
              <th>Просмотр</th>
              <th>Создать</th>
              <th>Изменить</th>
              <th>Удалить</th>
            </tr>
          </thead>
          <tbody>
            {initialPermissions.map((item) => (
              <tr key={item.name}>
                <td>{item.name}</td>
                {["view", "create", "edit", "delete"].map((col) => (
                  <td key={col}>
                    {item.columns.includes(col) ? (
                      <label className={styles.checkboxContainer}>
                        <input
                          type="checkbox"
                          checked={permissions[item.name][col] || false}
                          onChange={() => handleCheckboxChange(item.name, col)}
                        />
                        <span className={styles.customCheckbox}></span>
                      </label>
                    ) : null}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <button className={styles.saveButton}>Сохранить</button>
    </div>
  );
};

export default Misc;
